export default {
	title: "Options de présence",
	subtitle: "Configurez les plaintes et les ressources pour ce type de présence",
	label: "Nom",
	categories: {
		COMPLAINT: "Plainte",
		RESOURCE: "Ressource",
	},
	fieldTypes: {
		CHECKBOX: "Case à cocher",
		CHECKBOX_WITH_TEXT: "Case à cocher avec texte",
		QUANTITY: "Quantité",
	},
	form: {
		label: {
			label: "Nom de l'option",
			placeholder: "Ex. : Problème respiratoire, Bougies",
			hint: "Nom qui apparaîtra sur le ticket",
		},
		category: {
			label: "Catégorie",
			hint: "Plainte : ce qui sera traité. Ressource : ce qui sera utilisé.",
		},
		fieldType: {
			label: "Type de champ",
			hint: "Comment le praticien remplira cette option sur le ticket",
		},
	},
	create: "Ajouter une option",
	edit: "Modifier l'option",
	delete: "Supprimer l'option",
	deleteConfirmation: "Êtes-vous sûr de vouloir supprimer l'option \"{label}\" ?",
	messages: {
		created: "Option \"{label}\" créée avec succès",
		updated: "Option \"{label}\" mise à jour avec succès",
		deleted: "Option \"{label}\" supprimée avec succès",
		loadError: "Erreur lors du chargement des options",
		createError: "Erreur lors de la création de l'option",
		updateError: "Erreur lors de la mise à jour de l'option",
		deleteError: "Erreur lors de la suppression de l'option",
	},
	empty: {
		title: "Aucune option configurée",
		text: "Ajoutez des plaintes et des ressources pouvant être sélectionnées lors de l'émission de tickets de ce type de présence",
	},
	tabs: {
		complaints: "Plaintes",
		resources: "Ressources",
	},
	ticket: {
		sectionTitle: "Options de présence",
		complaints: "Plaintes",
		resources: "Ressources",
		customTextPlaceholder: "Décrivez...",
		quantityLabel: "Qté",
		topComplaint: "Plainte principale",
	},
	validation: {
		labelRequired: "Le nom est requis",
		categoryRequired: "La catégorie est requise",
	},
};
